import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-session-dialog',
  templateUrl: './session-dialog.component.html',
  styleUrls: ['./session-dialog.component.scss']
})
export class SessionDialogComponent implements OnInit {

  constructor( public activeModal: NgbActiveModal,) { }

  ngOnInit() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/session-dialog/session-dialog.component.ts